import { reactive as A, readonly as I, computed as c, defineComponent as P, renderSlot as p } from "vue";
class u {
  static instance;
  state;
  config;
  constructor(e) {
    this.state = A({
      isLoggedIn: !1,
      userInfo: null,
      loading: !1
    }), this.config = {
      loginUrl: "/login",
      homeUrl: "/",
      ...e
    };
  }
  static getInstance(e) {
    return u.instance || (u.instance = new u(e)), u.instance;
  }
  getState() {
    return I(this.state);
  }
  updateConfig(e) {
    this.config = { ...this.config, ...e };
  }
  async login() {
    this.config.loginHandler ? this.config.loginHandler() : window.location.href = this.config.loginUrl;
  }
  async logout() {
    this.state.loading = !0;
    try {
      this.config.logoutHandler && await this.config.logoutHandler(), this.state.isLoggedIn = !1, this.state.userInfo = null;
    } finally {
      this.state.loading = !1;
    }
  }
  async loadUserInfo() {
    this.state.loading = !0;
    try {
      if (this.config.loadUserInfoHandler) {
        const e = await this.config.loadUserInfoHandler();
        return e ? (this.state.userInfo = e, this.state.isLoggedIn = !0) : (this.state.userInfo = null, this.state.isLoggedIn = !1), e;
      }
      return null;
    } finally {
      this.state.loading = !1;
    }
  }
  setUserInfo(e) {
    e ? (this.state.userInfo = e, this.state.isLoggedIn = !0) : (this.state.userInfo = null, this.state.isLoggedIn = !1);
  }
  isAuthenticated() {
    return this.state.isLoggedIn;
  }
  async checkLogin() {
    return console.log("[AuthManager] checkLogin called, isAuthenticated:", this.isAuthenticated()), console.log("[AuthManager] loginConfirmHandler exists:", !!this.config.loginConfirmHandler), new Promise(async (e) => {
      if (this.isAuthenticated()) {
        e(!0);
        return;
      }
      if (this.config.loginConfirmHandler) {
        console.log("[AuthManager] Calling loginConfirmHandler");
        const t = await this.config.loginConfirmHandler();
        e(t);
        return;
      }
      console.log("[AuthManager] No loginConfirmHandler, calling login directly"), await this.login(), e(!1);
    });
  }
}
const o = u.getInstance();
class L {
  permissionChecker;
  constructor(e) {
    this.permissionChecker = e;
  }
  setPermissionChecker(e) {
    this.permissionChecker = e;
  }
  hasPermission(e) {
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : this.permissionChecker ? this.permissionChecker([e]) : t.userInfo.permissions.includes(e);
  }
  hasAnyPermission(e) {
    if (!e || e.length === 0)
      return !0;
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : this.permissionChecker ? this.permissionChecker(e) : e.some((i) => t.userInfo.permissions.includes(i));
  }
  hasAllPermissions(e) {
    if (!e || e.length === 0)
      return !0;
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : this.permissionChecker ? this.permissionChecker(e) : e.every((i) => t.userInfo.permissions.includes(i));
  }
  hasRole(e) {
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : t.userInfo.roles.includes(e);
  }
  hasAnyRole(e) {
    if (!e || e.length === 0)
      return !0;
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : e.some((i) => t.userInfo.roles.includes(i));
  }
  hasAllRoles(e) {
    if (!e || e.length === 0)
      return !0;
    const t = o.getState();
    return !t.isLoggedIn || !t.userInfo ? !1 : e.every((i) => t.userInfo.roles.includes(i));
  }
}
const l = new L();
class C {
  router = null;
  constructor(e) {
    e && (this.router = e, this.setupGuards());
  }
  setup(e) {
    this.router = e, this.setupGuards();
  }
  setupGuards() {
    this.router && this.router.beforeEach(async (e, t, i) => {
      if (!e)
        return i();
      const n = e.meta?.auth;
      if (!n?.requiresAuth)
        return i();
      const r = o.getState();
      if (!r.isLoggedIn && !r.loading && await o.loadUserInfo(), !o.getState().isLoggedIn)
        return await o.login(), i(!1);
      if (n.permissions && n.permissions.length > 0 && !l.hasAllPermissions(n.permissions) || n.roles && n.roles.length > 0 && !l.hasAnyRole(n.roles))
        return i(n.redirect || "/");
      i();
    });
  }
  addRouteGuard(e, t, i) {
    return new Promise(async (n) => {
      if (!e) {
        i(), n();
        return;
      }
      const r = e.meta?.auth;
      if (!r?.requiresAuth) {
        i(), n();
        return;
      }
      const a = o.getState();
      if (!a.isLoggedIn && !a.loading && await o.loadUserInfo(), !o.getState().isLoggedIn) {
        await o.login(), i(!1), n();
        return;
      }
      if (r.permissions && r.permissions.length > 0 && !l.hasAllPermissions(r.permissions)) {
        i(r.redirect || "/"), n();
        return;
      }
      if (r.roles && r.roles.length > 0 && !l.hasAnyRole(r.roles)) {
        i(r.redirect || "/"), n();
        return;
      }
      i(), n();
    });
  }
}
const H = new C();
function U() {
  const s = o.getState(), e = c(() => s.isLoggedIn), t = c(() => s.userInfo), i = c(() => s.loading);
  return {
    // State
    isLoggedIn: e,
    userInfo: t,
    loading: i,
    // Actions
    login: async () => {
      await o.login();
    },
    logout: async () => {
      await o.logout();
    },
    loadUserInfo: async () => await o.loadUserInfo(),
    checkLogin: async () => e.value ? !0 : await o.checkLogin(),
    // Auth manager instance
    authManager: o
  };
}
function b() {
  return {
    hasPermission: (a) => l.hasPermission(a),
    hasAnyPermission: (a) => l.hasAnyPermission(a),
    hasAllPermissions: (a) => l.hasAllPermissions(a),
    hasRole: (a) => l.hasRole(a),
    hasAnyRole: (a) => l.hasAnyRole(a),
    hasAllRoles: (a) => l.hasAllRoles(a),
    // Permission checker instance
    permissionChecker: l
  };
}
function E(s) {
  o.updateConfig(s), s.permissionChecker && l.setPermissionChecker(s.permissionChecker);
}
function v() {
  return {};
}
let k = (s) => {
  alert(s);
}, d = null;
function G(s) {
  d = s;
}
function h(s = {}) {
  const e = s.message || "您没有执行此操作的权限", t = s.title || "权限不足";
  d ? d(e, t) : k(e);
}
const w = {
  mounted(s, e) {
    y(s, e.value);
    const t = g(e.value);
    t.permissionType === "disable" && !t.hasPermission && t.prompt?.enabled && s.addEventListener("click", () => {
      h(t.prompt);
    });
  },
  updated(s, e) {
    y(s, e.value), s.removeEventListener("click", f);
    const t = g(e.value);
    t.permissionType === "disable" && !t.hasPermission && t.prompt?.enabled && s.addEventListener("click", f);
  },
  unmounted(s) {
    s.style.display = "", s.removeAttribute("disabled"), s.classList.remove("permission-disabled"), s.removeEventListener("click", f);
  }
};
function f(s) {
  const t = s.currentTarget.getAttribute("data-permission-config");
  if (t)
    try {
      const i = JSON.parse(t);
      h(i.prompt);
    } catch (i) {
      console.error("Failed to parse permission config:", i);
    }
  else
    h();
}
function g(s) {
  let e = !1, t = "hide", i = { enabled: !1 }, n = {};
  if (typeof s == "string")
    e = l.hasPermission(s);
  else if (Array.isArray(s))
    e = l.hasAnyPermission(s);
  else if (typeof s == "object")
    if ("prompt" in s && (i = { enabled: !0, ...s.prompt }), "events" in s && (n = { ...s.events }), "permission" in s && s.permission !== void 0) {
      const r = s;
      t = r.type || "hide", typeof r.permission == "string" ? e = l.hasPermission(r.permission) : Array.isArray(r.permission) && (e = l.hasAnyPermission(r.permission));
    } else "any" in s && s.any ? e = l.hasAnyPermission(s.any) : "all" in s && s.all && (e = l.hasAllPermissions(s.all));
  return { hasPermission: e, permissionType: t, prompt: i, events: n };
}
function y(s, e) {
  const { hasPermission: t, permissionType: i, prompt: n, events: r } = g(e);
  s.setAttribute("data-permission-config", JSON.stringify({ hasPermission: t, permissionType: i, prompt: n })), t ? (s.style.display = "", s.removeAttribute("disabled"), s.classList.remove("permission-disabled"), s.style.pointerEvents = "", s.removeAttribute("data-permission-hidden"), s.removeAttribute("data-permission-disabled")) : (r.onNoPermission && r.onNoPermission(), i === "hide" ? (s.style.display = "none", s.setAttribute("data-permission-hidden", "true")) : i === "disable" && (s.setAttribute("disabled", "disabled"), s.classList.add("permission-disabled"), s.style.pointerEvents = "none", s.setAttribute("data-permission-disabled", "true")));
}
function N(s) {
  s.directive("permission", w);
}
const O = /* @__PURE__ */ P({
  __name: "Permission",
  props: {
    permission: {},
    any: {},
    all: {},
    type: { default: "hide" }
  },
  setup(s) {
    const e = s, { hasPermission: t, hasAnyPermission: i, hasAllPermissions: n } = b(), r = c(() => {
      if (e.permission) {
        if (typeof e.permission == "string")
          return t(e.permission);
        if (Array.isArray(e.permission))
          return i(e.permission);
      } else {
        if (e.any)
          return i(e.any);
        if (e.all)
          return n(e.all);
      }
      return !0;
    });
    return (a, m) => r.value ? p(a.$slots, "default", { key: 0 }) : p(a.$slots, "fallback", { key: 1 });
  }
});
export {
  u as AuthManager,
  O as Permission,
  L as PermissionChecker,
  C as RouterGuard,
  o as authManager,
  E as configureAuth,
  v as getAuthConfig,
  l as permissionChecker,
  w as permissionDirective,
  H as routerGuard,
  G as setPermissionPromptHandler,
  N as setupPermissionDirective,
  U as useAuth,
  b as usePermission
};
